export default __webpack_public_path__ + "static/media/pdf-icon.53912815.svg";